import { createRouter, createWebHistory } from "vue-router";
import Home from "@/views/Home/index.vue";

const routes = [
  {
    path: "/",
    name: "Index",
    component: () => import("@/views/Index/index.vue"),
  },
  {
    path: "/home",
    name: "Home",
    component: Home,
  },
  {
    path: "/about",
    name: "About",
    component: () => import("@/views/About/index.vue"),
  },
  {
    path: "/download-app",
    name: "Download",
    component: () => import("@/views/DownLoad/DownLoad.vue"),
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to) {
    if (to.hash) {
      history.replaceState(history.state, "", " ");
      return {
        el: to.hash, // 滚动到对应的锚点
        behavior: "smooth", // 平滑滚动
      };
    }
    // 默认返回顶部
    return { top: 0 };
  },
  // linkActiveClass: "active",
});

export default router;
